"use client";

import Link from "next/link";
import { lazyComponent } from "@/components/ui/lazy-component";

export const LandingSpecSheetDemo = lazyComponent(
  () => import("./landing-tool-spec-sheet").then((module) => module.LandingToolSpecSheet),
  {
    loading: <div aria-hidden className="h-96 animate-pulse rounded-xl bg-foreground/5 motion-reduce:animate-none" />,
    ssr: false,
    failure: {
      label: "landing-spec-sheet-demo",
      fallback: (
        <p className="py-16 text-center text-sm text-fg-muted">
          The demo didn&apos;t load.{" "}
          <Link href="/packaging-designer" prefetch={false} className="font-medium text-brand-strong underline">
            Open the spec sheet builder
          </Link>
        </p>
      ),
    },
  },
);
